import { render, staticRenderFns } from "./Twilio.vue?vue&type=template&id=70ec383e&scoped=true"
import script from "./Twilio.vue?vue&type=script&lang=js"
export * from "./Twilio.vue?vue&type=script&lang=js"
import style0 from "./Twilio.vue?vue&type=style&index=0&id=70ec383e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ec383e",
  null
  
)

export default component.exports